import React, { useRef } from 'react'
import { useField, useFormikContext } from 'formik'

interface Props {
  name: string
  length?: number
}

export default function OTPInput({ name, length = 4 }: Props) {
  const [field, , helpers] = useField(name)
  const { setFieldValue } = useFormikContext()
  const inputsRef = useRef<(HTMLInputElement | null)[]>([])

  const value: string = field.value || ''

  const handleChange = (index: number, digit: string) => {
    if (!/^\d?$/.test(digit)) return

    const newValue =
      value.substring(0, index) +
      digit +
      value.substring(index + 1)

    setFieldValue(name, newValue)

    if (digit && index < length - 1) {
      inputsRef.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace') {
      if (!value[index] && index > 0) {
        inputsRef.current[index - 1]?.focus()
      }
    }
  }

  const handlePaste = (e: React.ClipboardEvent) => {
    const pasted = e.clipboardData.getData('text').slice(0, length)
    if (!/^\d+$/.test(pasted)) return

    setFieldValue(name, pasted)
    inputsRef.current[pasted.length - 1]?.focus()
  }

  return (
    <div className="flex justify-center gap-3" onPaste={handlePaste} dir="ltr" style={{ unicodeBidi: 'plaintext' }}>
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={value[index] || ''}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          className={`
            w-12 h-12
            text-center text-lg font-semibold
            border rounded-xl
            transition
            focus:outline-none
            ${
              value[index]
                ? 'border-primary text-primary'
                : 'border-gray-300'
            }
          `}
        />
      ))}
    </div>
  )
}
